import { Injectable } from '@angular/core';
import { LookupTableApiService } from '@cms/apis';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { LookupTableAction } from '../actions';

@Injectable()
export class LookupTableEffect {
  loadItem$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(LookupTableAction.loadItem),
      exhaustMap(action => {
        return this._apiService.getCommon(action.id).pipe(map(item => LookupTableAction.loadItemSuccess({ item })));
      })
    );
  });
  constructor(private _apiService: LookupTableApiService, private _actions$: Actions, private _store: Store) { }
}
